export function getFirstName(name?: string | null, fallback = '') {
  const value = name?.trim()
  if (!value) return fallback
  return value.split(/\s+/)[0] || fallback
}

/** Best-effort split of "First Last [Middle]" → {firstName, lastName}. */
export function splitDisplayName(name: string | null | undefined): {
  firstName: string
  lastName: string
} {
  if (!name) return { firstName: '', lastName: '' }
  const parts = name.trim().split(/\s+/)
  if (parts.length === 1) return { firstName: parts[0], lastName: '' }
  return {
    firstName: parts[0],
    lastName: parts.slice(1).join(' '),
  }
}
